import createClient from '../../apolloClient';
import MUTATION_DELETE_ESIM from '../../mutation/deleteEsim';

const handleDeleteEsim = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_DELETE_ESIM,
    variables,
  });
  const { deleteEsim } = result?.data || {};
  return deleteEsim;
};

export default handleDeleteEsim;
